export const addToStorage = (key: string, value: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(key, value);  // Client-side localStorage
    console.log(`Storing ${key}: ${value} in localStorage`);
  } else {
    // Server-side logic (in-memory or no storage)
    console.log(`Storing ${key}: ${value} in server-side storage (no localStorage available)`);
  }
};

export const getFromStorage = (key: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem(key);  // Client-side localStorage
  } else {
    // Server-side logic
    console.log(`Fetching ${key} in server-side storage (no localStorage available)`);
    return null;
  }
};

export const removeFromStorage = (key: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem(key);  // Client-side localStorage
    console.log(`Removing ${key} from localStorage`);
  } else {
    // Server-side logic
    console.log(`Removing ${key} from server-side storage (no localStorage available)`);
  }
};